import { Head, CleanContent } from './ui';
import { checks } from '../data';

export default function QualityStandards() {
  return (
    <CleanContent><section className="bg-soft py-5">
        <div className="container">
          <Head eyebrow="Certification Standards" title="Build a Showcase People Can Trust"
            text="Complete accuracy is the cornerstone of institutional respect: meet our 12 point Quality Check to unlock higher ranking eligibility" />
          <div className="row g-2">
            {checks.map((c) => (
              <div className="col-sm-6 col-lg-4" key={c}>
                <div className="bg-white border border-line rounded-3 px-3 py-2 p-sm text-dark">
                  <i className="bi bi-check-circle-fill check me-2" />{c}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section></CleanContent>
  );
}
